<template>
  <v-col cols="12 text-center">
    <div class="font-weight-bold text-h6 justify-center">
      ¿Está seguro de continuar con la desvinculación de
      {{ asignacion.nombre }} {{ asignacion.segundoNombre }} {{ asignacion.apaterno }} {{ asignacion.amaterno }}
      de este curso?
    </div>
    <div class="justify-center pb-8 mt-4">
      <TextButton color="red" @click="desvincular" :loading="loading" :disabled="loading"> Sí, Desvincular </TextButton>
    </div>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: { TextButton },
  props: {
    asignacion: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('cursoAsignado', ['updateDesvincularCursoPersonal']),
    async desvincular() {
      this.loading = true
      await this.updateDesvincularCursoPersonal(this.asignacion)
      this.loading = false
      this.$emit('close')
      this.$emit('updated')
    },
  },
}
</script>
